// import React, { useMemo, useState } from "react";
// import styles from "./HrmSettings.module.css";
// import { useAuth } from "../../components/context/Auth";
// import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
// import DropDown2 from "../../components/updatedComponents/FormComponents/Dropdown2";
// import CheckBox from "../../components/updatedComponents/FormComponents/CheckBox";
// import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
// const WEEKDAYS = [
//   "Sunday",
//   "Monday",
//   "Tuesday",
//   "Wednesday",
//   "Thursday",
//   "Friday",
//   "Saturday",
// ];

// const weekdayOptions = WEEKDAYS.map((d) => ({ label: d, value: d }));

// const STATUS_OPTIONS_LIST = [
//   { label: "Active", value: "Active" },
//   { label: "Inactive", value: "Inactive" },
// ];

// const INITIAL_SHIFTS = [
//   {
//     id: 1,
//     name: "Day Shift",
//     start: "09:00",
//     end: "18:00",
//     weeklyOff: "Sunday",
//     status: "Active",
//   },
//   {
//     id: 2,
//     name: "Night Shift",
//     start: "21:00",
//     end: "06:00",
//     weeklyOff: "Sunday",
//     status: "Active",
//   },
// ];

// // 24h "HH:MM" -> "9:00 AM" for display in the table
// const formatTime = (value) => {
//   if (!value) return "--:--";
//   const [h, m] = value.split(":").map(Number);
//   const period = h >= 12 ? "PM" : "AM";
//   const hour12 = h % 12 === 0 ? 12 : h % 12;
//   return `${hour12}:${String(m).padStart(2, "0")} ${period}`;
// };

// const emptyShiftForm = {
//   name: "",
//   start: "",
//   end: "",
//   weeklyOff: "Sunday",
//   status: "Active",
// };

// const designations = {
//   _id: "",
//   name: "",
// };

// const HrmSettings = () => {
//   const { mode } = useAuth();

//   // ── PF / ESI setup ──────────────────────────────────────────────────────
//   const [pfEsi, setPfEsi] = useState({
//     enablePF: true,
//     pfEmployeePercent: "8",
//     pfEmployerPercent: "4",
//     enableESI: true,
//     esiEmployeePercent: "0.75",
//     esiEmployerPercent: "3.25",
//   });

//   const updatePfEsi = (field, value) =>
//     setPfEsi((prev) => ({ ...prev, [field]: value }));

//   // ── Shifts ──────────────────────────────────────────────────────────────
//   const [shifts, setShifts] = useState(INITIAL_SHIFTS);
//   const [keyword, setKeyword] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [shiftForm, setShiftForm] = useState(emptyShiftForm);
//   const [designation, setDesignation] = useState(designations);
//   const [isDesigModalOpen, setIsDesigModalOpen] = useState(false);

//   const filteredShifts = useMemo(() => {
//     return shifts.filter((s) =>
//       s.name.toLowerCase().includes(keyword.toLowerCase()),
//     );
//   }, [shifts, keyword]);

//   const openCreateShift = () => {
//     setShiftForm(emptyShiftForm);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => setIsModalOpen(false);

//   const updateShiftForm = (field, value) =>
//     setShiftForm((prev) => ({ ...prev, [field]: value }));

//   const handleSaveShift = () => {
//     if (!shiftForm.name.trim() || !shiftForm.start || !shiftForm.end) return;

//     setShifts((prev) => [
//       ...prev,
//       {
//         id: Date.now(),
//         name: shiftForm.name.trim(),
//         start: shiftForm.start,
//         end: shiftForm.end,
//         weeklyOff: shiftForm.weeklyOff,
//         status: shiftForm.status,
//       },
//     ]);
//     setIsModalOpen(false);
//   };

//   const handleToggleStatus = (id) => {
//     setShifts((prev) =>
//       prev.map((s) =>
//         s.id === id
//           ? { ...s, status: s.status === "Active" ? "Inactive" : "Active" }
//           : s,
//       ),
//     );
//   };

//   const openAddDesignation = () => {
//     setDesignation(designations);
//     setIsDesigModalOpen(true);
//   };
//   const closeDesigModal = () => setIsDesigModalOpen(false);

//   const gridColumns = "0.5fr 1.2fr 0.9fr 0.9fr 0.9fr 0.8fr 1fr";

//   return (
//     <div
//       className={styles.settings}
//       style={mode ? { background: "#2C2E33", border: "none" } : {}}
//     >
//       {/* ── PF / ESI setup ──────────────────────────────────────────────── */}
//       <div
//         className={styles.sectionCard}
//         style={mode ? { background: "#232529" } : {}}
//       >
//         <h3 className={styles.sectionTitle}>PF / ESI setup</h3>

//         <div className={styles.pfEsiGrid}>
//           <label
//             className={`${styles.toggleCard} ${mode ? styles.toggleCardDark : ""}`}
//           >
//             <div>
//               <span className={styles.toggleLabel}>Enable PF</span>
//               <span className={styles.toggleHint}>
//                 Apply PF deduction where staff PF is applicable.
//               </span>
//             </div>

//             <CheckBox
//               checked={pfEsi.enablePF}
//               handleChange={(e) => updatePfEsi("enablePF", e.target.checked)}
//             />
//           </label>

//           <div className={styles.fieldGroup}>
//             <span className={styles.fieldLabel}>PF employee %</span>
//             <input
//               type="number"
//               className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
//               value={pfEsi.pfEmployeePercent}
//               onChange={(e) => updatePfEsi("pfEmployeePercent", e.target.value)}
//             />
//           </div>

//           <div className={styles.fieldGroup}>
//             <span className={styles.fieldLabel}>PF employer %</span>
//             <input
//               type="number"
//               className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
//               value={pfEsi.pfEmployerPercent}
//               onChange={(e) => updatePfEsi("pfEmployerPercent", e.target.value)}
//             />
//           </div>

//           <label
//             className={`${styles.toggleCard} ${mode ? styles.toggleCardDark : ""}`}
//           >
//             <div>
//               <span className={styles.toggleLabel}>Enable ESI</span>
//               <span className={styles.toggleHint}>
//                 Apply ESI deduction where staff ESI is applicable.
//               </span>
//             </div>

//             <CheckBox
//               checked={pfEsi.enableESI}
//               handleChange={(e) => updatePfEsi("enableESI", e.target.checked)}
//             />
//           </label>

//           <div className={styles.fieldGroup}>
//             <span className={styles.fieldLabel}>ESI employee %</span>
//             <input
//               type="number"
//               className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
//               value={pfEsi.esiEmployeePercent}
//               onChange={(e) =>
//                 updatePfEsi("esiEmployeePercent", e.target.value)
//               }
//             />
//           </div>

//           <div className={styles.fieldGroup}>
//             <span className={styles.fieldLabel}>ESI employer %</span>
//             <input
//               type="number"
//               className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
//               value={pfEsi.esiEmployerPercent}
//               onChange={(e) =>
//                 updatePfEsi("esiEmployerPercent", e.target.value)
//               }
//             />
//           </div>
//         </div>

//         <div>
//           <div className={styles.designationTop}>
//             <h3 className={styles.sectionTitle}>Designations</h3>
//             <button
//               type="button"
//               className={styles.addShiftBtn}
//               onClick={openAddDesignation}
//             >
//               + Add Designation
//             </button>
//           </div>
//         </div>

//       </div>

//       {/* ── Shift management ────────────────────────────────────────────── */}
//       <div
//         className={styles.sectionCard}
//         style={mode ? { background: "#232529" } : {}}
//       >
//         <div className={styles.shiftTopBar}>
//           <h3 className={styles.sectionTitle}>Shift List</h3>

//           <div className={styles.shiftTopBarRight}>
//             <SearchBar
//               placeholder="Search Shift..."
//               value={keyword}
//               padding="5px 10px"
//               onChange={(e) => setKeyword(e.target.value)}
//               onClear={() => setKeyword("")}
//             />
//             <button
//               type="button"
//               className={styles.addShiftBtn}
//               onClick={openCreateShift}
//             >
//               + Add Shift
//             </button>
//           </div>
//         </div>

//         {/* Header stays fixed; only the rows below it scroll once the
//             list grows past the wrapper's max-height. */}
//         <div className={styles.shiftTableWrap}>
//           <div
//             className={styles.shiftTableHeader}
//             style={{
//               gridTemplateColumns: gridColumns,
//               background: mode ? "#2C2E31" : "#d9dce5",
//               color: mode ? "#fff" : "#646b88",
//             }}
//           >
//             <div>S.No.</div>
//             <div>Shift</div>
//             <div>Start</div>
//             <div>End</div>
//             <div>Weekly Off</div>
//             <div>Status</div>
//             <div>Action</div>
//           </div>

//           <ul className={styles.shiftTableBody}>
//             {filteredShifts.length === 0 && (
//               <li className={styles.shiftEmptyRow}>
//                 No shifts match "{keyword}".
//               </li>
//             )}

//             {filteredShifts.map((shift, index) => (
//               <li
//                 key={shift.id}
//                 className={`${styles.shiftTableRow} ${mode ? styles.shiftTableRowDark : ""}`}
//                 style={{ gridTemplateColumns: gridColumns }}
//               >
//                 <div>{index + 1}</div>

//                 <div className={styles.shiftNameCell}>{shift.name}</div>
//                 <div>{formatTime(shift.start)}</div>
//                 <div>{formatTime(shift.end)}</div>
//                 <div>{shift.weeklyOff}</div>
//                 <div>
//                   <span
//                     className={
//                       shift.status === "Active"
//                         ? styles.statusActive
//                         : styles.statusInactive
//                     }
//                   >
//                     {shift.status}
//                   </span>
//                 </div>
//                 <div>
//                   <button
//                     type="button"
//                     className={
//                       shift.status === "Active"
//                         ? styles.disableBtn
//                         : styles.enableBtn
//                     }
//                     onClick={() => handleToggleStatus(shift.id)}
//                   >
//                     {shift.status === "Active" ? "Disable" : "Enable"}
//                   </button>
//                 </div>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>

//       {/* ── Create Shift modal ──────────────────────────────────────────── */}
//       {isModalOpen && (
//         <div className={styles.modalOverlay} onClick={closeModal}>
//           <div
//             className={`${styles.modalCard} ${mode ? styles.modalCardDark : ""}`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               type="button"
//               className={styles.modalCloseBtn}
//               onClick={closeModal}
//             >
//               &times;
//             </button>

//             {/* <p className={styles.modalEyebrow}>SHIFT</p> */}
//             <h2 className={styles.modalTitle}>Create Shift</h2>

//             <div className={styles.formGrid}>
//               <div className={styles.fieldGroup}>
//                 <span className={styles.fieldLabel}>Shift Name</span>
//                 <input
//                   type="text"
//                   className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
//                   placeholder="Evening Shift"
//                   value={shiftForm.name}
//                   onChange={(e) => updateShiftForm("name", e.target.value)}
//                 />
//               </div>

//               <div className={styles.fieldGroup}>
//                 <span className={styles.fieldLabel}>Start Time</span>
//                 <input
//                   type="time"
//                   className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
//                   value={shiftForm.start}
//                   onChange={(e) => updateShiftForm("start", e.target.value)}
//                 />
//               </div>

//               <div className={styles.fieldGroup}>
//                 <span className={styles.fieldLabel}>End Time</span>
//                 <input
//                   type="time"
//                   className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
//                   value={shiftForm.end}
//                   onChange={(e) => updateShiftForm("end", e.target.value)}
//                 />
//               </div>

//               <div className={styles.fieldGroup}>
//                 <span className={styles.fieldLabel}>Weekly Off</span>

//                 <DropDown2
//                   options={weekdayOptions.map((d) => ({
//                     name: d.label,
//                     value: d.value,
//                   }))}
//                   onSelect={(val) => updateShiftForm("weeklyOff", val.value)}
//                 />
//               </div>

//               <div className={styles.fieldGroup}>
//                 <span className={styles.fieldLabel}>Status</span>
//                 <DropDown2
//                   options={STATUS_OPTIONS_LIST.map((s) => ({
//                     name: s.label,
//                     value: s.value,
//                   }))}
//                   onSelect={(val) => updateShiftForm("status", val.value)}
//                 />
//               </div>
//             </div>

//             <div className={styles.modalActions}>
//               <button
//                 type="button"
//                 className={styles.cancelBtn}
//                 onClick={closeModal}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className={styles.saveBtn}
//                 onClick={handleSaveShift}
//               >
//                 Save Shift
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Create Designation modal ──────────────────────────────────────────── */}

//       {isDesigModalOpen && (
//         <div className={styles.modalOverlay} onClick={closeDesigModal}>
//           <div
//             className={`${styles.modalCard} ${mode ? styles.modalCardDark : ""}`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               type="button"
//               className={styles.modalCloseBtn}
//               onClick={closeModal}
//             >
//               &times;
//             </button>

//             <h2 className={styles.modalTitle}>Add Designation</h2>

//             <div className={styles.fieldGroup}>
//               <div>
//                 <input
//                   type="text"
//                   className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
//                   placeholder="Enter Designation Name"
//                   value={shiftForm.name}
//                   onChange={(e) => updateShiftForm("name", e.target.value)}
//                 />
//               </div>
//             </div>

//             <div style={{marginTop:'10px'}} className={styles.modalActions}>
//               <button
//                 type="button"
//                 className={styles.cancelBtn}
//                 onClick={closeDesigModal}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className={styles.saveBtn}
//                 // onClick={handleSaveDesignation}
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default HrmSettings;

import React, { useMemo, useState } from "react";
import styles from "./HrmSettings.module.css";
import { useAuth } from "../../components/context/Auth";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import DropDown2 from "../../components/updatedComponents/FormComponents/Dropdown2";
import CheckBox from "../../components/updatedComponents/FormComponents/CheckBox";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";

const WEEKDAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const weekdayOptions = WEEKDAYS.map((d) => ({ label: d, value: d }));

const STATUS_OPTIONS_LIST = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
];

const INITIAL_SHIFTS = [
  {
    id: 1,
    name: "Day Shift",
    start: "09:00",
    end: "18:00",
    weeklyOff: "Sunday",
    status: "Active",
  },
  {
    id: 2,
    name: "Night Shift",
    start: "21:00",
    end: "06:00",
    weeklyOff: "Sunday",
    status: "Active",
  },
  {
    id: 3,
    name: "Evening Shift",
    start: "14:00",
    end: "23:00",
    weeklyOff: "Monday",
    status: "Inactive",
  },
];

const INITIAL_DESIGNATIONS = [
  { id: 1, name: "Manager" },
  { id: 2, name: "Software Engineer" },
  { id: 3, name: "HR Executive" },
  { id: 4, name: "Team Lead" },
  { id: 5, name: "Accountant" },
];

// 24h "HH:MM" -> "9:00 AM" for display on shift cards
const formatTime = (value) => {
  if (!value) return "--:--";
  const [h, m] = value.split(":").map(Number);
  const period = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}:${String(m).padStart(2, "0")} ${period}`;
};

const emptyShiftForm = {
  name: "",
  start: "",
  end: "",
  weeklyOff: "Sunday",
  status: "Active",
};

const HrmSettings = () => {
  const { mode } = useAuth();

  // ── PF / ESI setup ──────────────────────────────────────────────────────
  const [pfEsi, setPfEsi] = useState({
    enablePF: true,
    pfEmployeePercent: "8",
    pfEmployerPercent: "4",
    enableESI: true,
    esiEmployeePercent: "0.75",
    esiEmployerPercent: "3.25",
  });

  const updatePfEsi = (field, value) =>
    setPfEsi((prev) => ({ ...prev, [field]: value }));

  // ── Shifts ──────────────────────────────────────────────────────────────
  const [shifts, setShifts] = useState(INITIAL_SHIFTS);
  const [keyword, setKeyword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [shiftForm, setShiftForm] = useState(emptyShiftForm);

  const filteredShifts = useMemo(() => {
    return shifts.filter((s) =>
      s.name.toLowerCase().includes(keyword.toLowerCase()),
    );
  }, [shifts, keyword]);

  const openCreateShift = () => {
    setShiftForm(emptyShiftForm);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const updateShiftForm = (field, value) =>
    setShiftForm((prev) => ({ ...prev, [field]: value }));

  const handleSaveShift = () => {
    if (!shiftForm.name.trim() || !shiftForm.start || !shiftForm.end) return;

    setShifts((prev) => [
      ...prev,
      {
        id: Date.now(),
        name: shiftForm.name.trim(),
        start: shiftForm.start,
        end: shiftForm.end,
        weeklyOff: shiftForm.weeklyOff,
        status: shiftForm.status,
      },
    ]);
    setIsModalOpen(false);
  };

  const handleToggleStatus = (id) => {
    setShifts((prev) =>
      prev.map((s) =>
        s.id === id
          ? { ...s, status: s.status === "Active" ? "Inactive" : "Active" }
          : s,
      ),
    );
  };

  // ── Designations ─────────────────────────────────────────────────────────
  const [designationsList, setDesignationsList] =
    useState(INITIAL_DESIGNATIONS);
  const [designationKeyword, setDesignationKeyword] = useState("");
  const [quickDesignation, setQuickDesignation] = useState("");

  const filteredDesignations = useMemo(() => {
    return designationsList.filter((d) =>
      d.name.toLowerCase().includes(designationKeyword.toLowerCase()),
    );
  }, [designationsList, designationKeyword]);

  const handleQuickAddDesignation = () => {
    const name = quickDesignation.trim();
    if (!name) return;

    setDesignationsList((prev) => [...prev, { id: Date.now(), name }]);
    setQuickDesignation("");
  };

  const handleQuickAddKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleQuickAddDesignation();
    }
  };

  const handleDeleteDesignation = (id) => {
    setDesignationsList((prev) => prev.filter((d) => d.id !== id));
  };

  return (
    <div
      className={styles.settings}
      style={mode ? { background: "#2C2E33", border: "none" } : {}}
    >
      {/* ── PF / ESI setup ──────────────────────────────────────────────── */}
      <div
        className={styles.sectionCard}
        style={mode ? { background: "#232529" } : {}}
      >
        <h3 className={styles.sectionTitle}>PF / ESI setup</h3>

        <div className={styles.pfEsiGrid}>
          <label
            className={`${styles.toggleCard} ${mode ? styles.toggleCardDark : ""}`}
          >
            <div>
              <span className={styles.toggleLabel}>Enable PF</span>
              <span className={styles.toggleHint}>
                Apply PF deduction where staff PF is applicable.
              </span>
            </div>

            <CheckBox
              checked={pfEsi.enablePF}
              handleChange={(e) => updatePfEsi("enablePF", e.target.checked)}
            />
          </label>

          <div className={styles.fieldGroup}>
            <span className={styles.fieldLabel}>PF employee %</span>
            <input
              type="number"
              className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
              value={pfEsi.pfEmployeePercent}
              onChange={(e) => updatePfEsi("pfEmployeePercent", e.target.value)}
            />
          </div>

          <div className={styles.fieldGroup}>
            <span className={styles.fieldLabel}>PF employer %</span>
            <input
              type="number"
              className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
              value={pfEsi.pfEmployerPercent}
              onChange={(e) => updatePfEsi("pfEmployerPercent", e.target.value)}
            />
          </div>

          <label
            className={`${styles.toggleCard} ${mode ? styles.toggleCardDark : ""}`}
          >
            <div>
              <span className={styles.toggleLabel}>Enable ESI</span>
              <span className={styles.toggleHint}>
                Apply ESI deduction where staff ESI is applicable.
              </span>
            </div>

            <CheckBox
              checked={pfEsi.enableESI}
              handleChange={(e) => updatePfEsi("enableESI", e.target.checked)}
            />
          </label>

          <div className={styles.fieldGroup}>
            <span className={styles.fieldLabel}>ESI employee %</span>
            <input
              type="number"
              className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
              value={pfEsi.esiEmployeePercent}
              onChange={(e) =>
                updatePfEsi("esiEmployeePercent", e.target.value)
              }
            />
          </div>

          <div className={styles.fieldGroup}>
            <span className={styles.fieldLabel}>ESI employer %</span>
            <input
              type="number"
              className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
              value={pfEsi.esiEmployerPercent}
              onChange={(e) =>
                updatePfEsi("esiEmployerPercent", e.target.value)
              }
            />
          </div>
        </div>
      </div>

      {/* ── Shift cards (70%) + Designation tags (30%) ──────────────────── */}
      <div className={styles.tablesRow}>
        {/* Shift management — card grid */}
        <div
          className={`${styles.sectionCard} ${styles.shiftSection}`}
          style={mode ? { background: "#232529" } : {}}
        >
          <div className={styles.topBar}>
            <h3 className={styles.sectionTitle}>Shift List</h3>

            <div className={styles.topBarRight}>
              <SearchBar
                placeholder="Search Shift..."
                value={keyword}
                padding="5px 10px"
                onChange={(e) => setKeyword(e.target.value)}
                onClear={() => setKeyword("")}
              />
              <button
                type="button"
                className={styles.addBtn}
                onClick={openCreateShift}
              >
                + Add Shift
              </button>
            </div>
          </div>

          <div className={styles.shiftCardGrid}>
            {filteredShifts.length === 0 && (
              <div className={styles.emptyState}>
                No shifts match "{keyword}".
              </div>
            )}

            {filteredShifts.map((shift, index) => (
              <div
                key={shift.id}
                className={`${styles.shiftCard} ${mode ? styles.shiftCardDark : ""} ${
                  shift.status === "Inactive" ? styles.shiftCardInactive : ""
                }`}
              >
                <div className={styles.shiftCardTop}>
                  <span className={styles.shiftCardName}>{shift.name}</span>
                  <span className={styles.shiftCardIndex}>
                    #{String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <div className={styles.shiftCardTime}>
                  {formatTime(shift.start)}{" "}
                  <span className={styles.arrow}>→</span>{" "}
                  {formatTime(shift.end)}
                </div>

                <div className={styles.shiftCardMeta}>
                  <span className={styles.weeklyOffPill}>
                    Off: {shift.weeklyOff}
                  </span>
                  <span
                    className={
                      shift.status === "Active"
                        ? styles.statusPillActive
                        : styles.statusPillInactive
                    }
                  >
                    {shift.status}
                  </span>
                </div>

                <button
                  type="button"
                  className={
                    shift.status === "Active"
                      ? styles.cardActionDisable
                      : styles.cardActionEnable
                  }
                  onClick={() => handleToggleStatus(shift.id)}
                >
                  {shift.status === "Active" ? "Disable" : "Enable"}
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Designations — tag cloud */}
        <div
          className={`${styles.sectionCard} ${styles.designationSection}`}
          style={mode ? { background: "#232529" } : {}}
        >
          <div>
            <h3 className={styles.sectionTitle}>Designations</h3>
            <br />
            <p className={styles.sectionSub}>Add and manage job titles</p>
          </div>

          <div className={styles.desigInlineAdd}>
            <input
              type="text"
              className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
              placeholder="New designation..."
              value={quickDesignation}
              onChange={(e) => setQuickDesignation(e.target.value)}
              onKeyDown={handleQuickAddKeyDown}
            />
            <button
              type="button"
              className={styles.addBtn}
              onClick={handleQuickAddDesignation}
            >
              + Add Designation
            </button>
          </div>

          <SearchBar
            placeholder="Search Designation..."
            value={designationKeyword}
            padding="5px 10px"
            onChange={(e) => setDesignationKeyword(e.target.value)}
            onClear={() => setDesignationKeyword("")}
          />

          <div className={styles.tagCloud}>
            {filteredDesignations.length === 0 && (
              <div className={styles.tagEmpty}>
                No designations match "{designationKeyword}".
              </div>
            )}

            {filteredDesignations.map((d) => (
              <span
                key={d.id}
                className={`${styles.tagChip} ${mode ? styles.tagChipDark : ""}`}
              >
                <span className={styles.dot} />
                {d.name}
                <button
                  type="button"
                  aria-label={`Remove ${d.name}`}
                  onClick={() => handleDeleteDesignation(d.id)}
                >
                  &times;
                </button>
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* ── Create Shift modal ──────────────────────────────────────────── */}
      {isModalOpen && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div
            className={`${styles.modalCard} ${mode ? styles.modalCardDark : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className={styles.modalCloseBtn}
              onClick={closeModal}
            >
              &times;
            </button>

            <h2 className={styles.modalTitle}>Create Shift</h2>

            <div className={styles.formGrid}>
              <div className={styles.fieldGroup}>
                <span className={styles.fieldLabel}>Shift Name</span>
                <input
                  type="text"
                  className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
                  placeholder="Evening Shift"
                  value={shiftForm.name}
                  onChange={(e) => updateShiftForm("name", e.target.value)}
                />
              </div>

              <div className={styles.fieldGroup}>
                <span className={styles.fieldLabel}>Start Time</span>
                <input
                  type="time"
                  className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
                  value={shiftForm.start}
                  onChange={(e) => updateShiftForm("start", e.target.value)}
                />
              </div>

              <div className={styles.fieldGroup}>
                <span className={styles.fieldLabel}>End Time</span>
                <input
                  type="time"
                  className={`${styles.textInput} ${mode ? styles.textInputDark : ""}`}
                  value={shiftForm.end}
                  onChange={(e) => updateShiftForm("end", e.target.value)}
                />
              </div>

              <div className={styles.fieldGroup}>
                <span className={styles.fieldLabel}>Weekly Off</span>

                <DropDown2
                  options={weekdayOptions.map((d) => ({
                    name: d.label,
                    value: d.value,
                  }))}
                  onSelect={(val) => updateShiftForm("weeklyOff", val.value)}
                />
              </div>

              <div className={styles.fieldGroup}>
                <span className={styles.fieldLabel}>Status</span>
                <DropDown2
                  options={STATUS_OPTIONS_LIST.map((s) => ({
                    name: s.label,
                    value: s.value,
                  }))}
                  onSelect={(val) => updateShiftForm("status", val.value)}
                />
              </div>
            </div>

            <div className={styles.modalActions}>
              <button
                type="button"
                className={styles.cancelBtn}
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className={styles.saveBtn}
                onClick={handleSaveShift}
              >
                Save Shift
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HrmSettings;
